'use strict';

var React = require('react');

function PortalsContainerComponent(_props, ref) {
  return /*#__PURE__*/React.createElement("div", {
    id: "PolarisPortalsContainer",
    ref: ref
  });
}
const PortalsContainer = /*#__PURE__*/React.forwardRef(PortalsContainerComponent);

exports.PortalsContainer = PortalsContainer;
